export default __webpack_public_path__ + "123c7f915116c0c207b5fb9c2e6b3992.svg";